import store from '@/store';
import { crmContactValidateRepository } from '@/forms/api/repository-factory';
import callApi from '@/lib/helpers/call-api';

const getPayload = () => {
    const { appId, } = store.state;
    return {

        "app-id": appId,
        "validation-type": "mobilephone"
    };
};

export default {
    async crmContactValidate(currentStep, callbacks) {
        const { form } = currentStep;
        let response = false;
        response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: crmContactValidateRepository.crmContactValidate,
            payload: getPayload(),
        });
    }
};